import React, { ReactNode } from 'react';
import { IconStarSolid } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { PDPCustomAttributeKeys } from '@common/test-automation';
import { numberWithPlusSignByMaxCount } from '@common/utils';

export interface RatingsProps {
  className?: string;
  ratings_average: number;
  review_count: number;
  display_review_count: boolean | null;
  onClickViewAll: () => void;
  after_addon?: ReactNode;
}

export const Ratings: React.FC<React.PropsWithChildren<RatingsProps>> = ({
  className,
  ratings_average,
  review_count,
  display_review_count,
  onClickViewAll,
  after_addon,
}) => {
  return (
    <Wrapper className={className} is_no_review={review_count === 0}>
      {Boolean(review_count) && (
        <>
          <IconStarSolid width={19} height={19} v3Color='yellow300' />
          <Average>{ratings_average.toFixed(1)}</Average>
          {display_review_count && (
            <Text onClick={onClickViewAll} data-custom-ta-key={PDPCustomAttributeKeys.PDP_REVIEW_COUNT_2}>
              리뷰 {numberWithPlusSignByMaxCount(review_count, 99999)}
            </Text>
          )}
        </>
      )}
      {after_addon}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ is_no_review: boolean }>`
  padding: 0 16px 0 14px;
  display: flex;
  align-items: center;
  height: 18px;
  ${({ is_no_review }) =>
    is_no_review &&
    css`
      height: 8px;
    `}
`;

const Average = styled.div`
  margin: 0 0 0 1px;
  font-size: 12px;
  font-weight: 500;
  color: ${vars.color.textTertiary};
`;

const Text = styled.div`
  padding: 11px 0;
  margin: 0 0 0 5px;
  font-size: 12px;
  font-weight: 500;
  color: ${vars.color.textPrimary};
  text-decoration: underline;
`;
